module.exports = __webpack_public_path__ + "img/jingzhuang5.2be432df.jpg";